export { default } from './switch';
